import { DEMO_CONNECTION_INDEX } from 'portal-sdk';

import { usePortalConnectionByIndex } from 'src/utils/hooks/usePortalConnectionByIndex';

/**
 * Returns the "demo" portal connection which isn't included in lists
 */
export const usePortalDemoConnection = () => {
  return usePortalConnectionByIndex(DEMO_CONNECTION_INDEX, false).data || null;
};
